import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Split translation files — grouped by feature
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enMarket from './locales/en/market.json';
import enTrading from './locales/en/trading.json';
import enScanner from './locales/en/scanner.json';
import enPortfolio from './locales/en/portfolio.json';
import enLegendary from './locales/en/legendary.json';
import enTrendPredictions from './locales/en/trendPredictions.json';
import enRiskML from './locales/en/riskML.json';
import enUpsideML from './locales/en/upsideML.json';
import enPatternCluster from './locales/en/patternCluster.json';
import enSmartMoney from './locales/en/smartMoney.json';
import enRiskComposite from './locales/en/riskComposite.json';
import enPivotPoints from './locales/en/pivotPoints.json';
import enDarvasBox from './locales/en/darvasBox.json';
import enVsa from './locales/en/vsa.json';
import enTplus from './locales/en/tplus.json';
import enMoneyFlow from './locales/en/moneyFlow.json';
import enDistribution from './locales/en/distribution.json';
import enRegimeWatchlist from './locales/en/regimeWatchlist.json';
import enStatistical from './locales/en/statistical.json';
import enIcbIndustry from './locales/en/icbIndustry.json';
import enBottomingFlow from './locales/en/bottomingFlow.json';
import enMarketPhaseDashboard from './locales/en/marketPhaseDashboard.json';

import viCommon from './locales/vi/common.json';
import viDashboard from './locales/vi/dashboard.json';
import viMarket from './locales/vi/market.json';
import viTrading from './locales/vi/trading.json';
import viScanner from './locales/vi/scanner.json';
import viPortfolio from './locales/vi/portfolio.json';
import viLegendary from './locales/vi/legendary.json';
import viTrendPredictions from './locales/vi/trendPredictions.json';
import viRiskML from './locales/vi/riskML.json';
import viUpsideML from './locales/vi/upsideML.json';
import viPatternCluster from './locales/vi/patternCluster.json';
import viSmartMoney from './locales/vi/smartMoney.json';
import viRiskComposite from './locales/vi/riskComposite.json';
import viPivotPoints from './locales/vi/pivotPoints.json';
import viDarvasBox from './locales/vi/darvasBox.json';
import viVsa from './locales/vi/vsa.json';
import viTplus from './locales/vi/tplus.json';
import viMoneyFlow from './locales/vi/moneyFlow.json';
import viDistribution from './locales/vi/distribution.json';
import viRegimeWatchlist from './locales/vi/regimeWatchlist.json';
import viStatistical from './locales/vi/statistical.json';
import viIcbIndustry from './locales/vi/icbIndustry.json';
import viBottomingFlow from './locales/vi/bottomingFlow.json';
import viMarketPhaseDashboard from './locales/vi/marketPhaseDashboard.json';

// Deep-merge locale chunks so feature blocks like `alerts`
// can be extended across files without overwriting each other.
const isPlainObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

const deepMerge = (target, source) => {
  const output = { ...target };
  Object.entries(source || {}).forEach(([key, value]) => {
    if (isPlainObject(value) && isPlainObject(output[key])) {
      output[key] = deepMerge(output[key], value);
    } else {
      output[key] = value;
    }
  });
  return output;
};

const mergeAll = (...chunks) => chunks.reduce((acc, chunk) => deepMerge(acc, chunk), {});

// the translations
const resources = {
  en: {
    translation: mergeAll(enCommon, enDashboard, enMarket, enTrading, enScanner, enPortfolio, enLegendary, enTrendPredictions, enRiskML, enUpsideML, enPatternCluster, enSmartMoney, enRiskComposite, enPivotPoints, enDarvasBox, enVsa, enTplus, enMoneyFlow, enDistribution, enRegimeWatchlist, enStatistical, enIcbIndustry, enBottomingFlow, enMarketPhaseDashboard)
  },
  vi: {
    translation: mergeAll(viCommon, viDashboard, viMarket, viTrading, viScanner, viPortfolio, viLegendary, viTrendPredictions, viRiskML, viUpsideML, viPatternCluster, viSmartMoney, viRiskComposite, viPivotPoints, viDarvasBox, viVsa, viTplus, viMoneyFlow, viDistribution, viRegimeWatchlist, viStatistical, viIcbIndustry, viBottomingFlow, viMarketPhaseDashboard)
  }
};

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    // lng: 'en', // Remove force English - let detection work
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    }
  });

export default i18n;

